import Component from './Header'

export default Component